namespace Gamification.Gamification {
    export interface UtentiDatiForm {
        UserId: Serenity.IntegerEditor;
        IdAzienda: Serenity.LookupEditor;
        Api: Serenity.LookupEditor;
        Cognome: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        Bloccato: Serenity.BooleanEditor;
    }

    export class UtentiDatiForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiDati';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiDatiForm.init)  {
                UtentiDatiForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.BooleanEditor;

                Q.initFormType(UtentiDatiForm, [
                    'UserId', w0,
                    'IdAzienda', w1,
                    'Api', w1,
                    'Cognome', w2,
                    'Nome', w2,
                    'Email', w2,
                    'Bloccato', w3
                ]);
            }
        }
    }
}
